import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        route:{
            name:'',
            viewType:'',
        },
        back:{
            lastIndex:-1,
            list:new Array(),
        },
        window:{
            height:0,
            width:0,
            scrollY:0
        },
        pageMask:{
            showAt: false,
            axiosCtrlAt: true
        },
        popup: {
            showAt: false,
            list: new Array()
        },
        dayInfo:{
            ymd:'',
            yy:'',
            mm:'',
            dd:'',
            dayNum:'',
            dayKor:'',
            dayKor2:'',
            nrtrYear:''
        },
        login:{
            loginAt : false,
            mberInfo: {
                mberNo : '',
                mberNm : '',
                id : '',
                sttus : '',
                cttpc : '',
                email : '',
                joinCours:'',
                jkUseAt: '',
            }
        }

    },
    getters: {
        getRouteInfo: function(state,){
            return state.route;
        },
        getBackInfo: function(state){
            let backInfo = null;
            if(state.back.lastIndex > -1){
                backInfo = state.back.list[state.back.lastIndex];
                backInfo = {
                    func: backInfo.func,
                    params: backInfo.params,
                    index: state.back.lastIndex,
                };
            }

            return backInfo;
        },
        getWindowInfo: function(state){
            return state.window;
        },
        getPageMaskShowAt: function(state) {
            return state.pageMask.showAt;
        },
        getPopupInfo: function(state) {
            return state.popup;
        },
        getDayInfo: function (state) {
            return state.dayInfo;
        },
        getPageMaskAxiosCtrlAt: function(state){
            return  state.pageMask.axiosCtrlAt;
        },
        getLoginAt: function(state){
            return state.login.loginAt;
        },
        getMberInfo: function(state){
            return state.login.mberInfo;
        }
    },
    mutations: {
        setRouteInfo: function(state, payload){
            state.route[payload.trget] = payload.value;
            return state.route;
        },
        setBackList: function(state, payload){
            state.back.list.push(payload);
            state.back.lastIndex = state.back.list.length - 1;
            return state.back;
        },
        removeBackInfo: function(state){
            state.back.list.splice(state.back.lastIndex,1);
            const cnt = state.back.list.length;
            if(cnt == 0) state.back.lastIndex = -1;
            else state.back.lastIndex = cnt - 1;
            return state.back;
        },
        setWindowWidthHeight: function(state, payload){
            state.window.width = payload.width;
            state.window.height = payload.height;
            return state.window;
        },
        setWindowScrollY: function(state, payload){
            state.window.scrollY = payload;
            return state.window;
        },
        setPageMaskShowAt: function(state, payload){
            state.pageMask.showAt = payload;
            if(!payload){
                state.pageMask.axiosCtrl = true;
            }
            return  state.pageMask.showAt;
        },
        setPageMaskAxiosCtrlAt: function(state, payload){
            state.pageMask.axiosCtrlAt = payload;
            return  state.pageMask.axiosCtrlAt;
        },
        setDayInfo: function(state, payload){
            state.dayInfo = payload;
            return state.dayInfo;
        },
        setMberInfo : function(state, payload){
            state.login.loginAt  = true;

            state.login.mberInfo = payload;
            state.login.mberInfo.mberNo = payload.mberNo;
            state.login.mberInfo.mberNm = payload.mberNm;
            state.login.mberInfo.id     = payload.id;
            state.login.mberInfo.sttus  = payload.sttus;
            state.login.mberInfo.cttpc  = payload.cttpc;
            state.login.mberInfo.email  = payload.email;
            state.login.mberInfo.joinCours  = payload.joinCours;
            state.login.mberInfo.jkUseAt  = payload.jkUseAt;

            return state.login.mberInfo;
        },
        clearLoginInfo: function(state){
            state.login.loginAt  = false;

            state.login.mberInfo = {
                mberNo: '',
                mberNm: '',
                id: '',
                sttus: '',
                cttpc: '',
                email: ''
            };

            return state.login.loginAt;
        },
        setPopupShowAt: function(state, payload){
            state.popup.showAt = payload;
            return state.popup.showAt;
        },
        openPopup: function(state, payload){
            state.popup.list.push(payload);
            return state.popup.list;
        },
        closePopup: function(state, payload){
            state.popup.list.splice(payload,1);
            return state.popup.list;
        },
        movePage: function(){

        }
    },
    actions: {
        searchDayInfo: function(context){
            return axios.post(
                '/common/day/searchDayInfo.act',
                {}
            ).then(function(response) {
                const dayInfo = response.data.dayInfo;
                if(typeof dayInfo != 'undefined'&&dayInfo != null){
                    context.commit('setDayInfo', response.data.dayInfo);
                }
            }.bind(this)).catch(function(e) {
                console.log(e);
            });
        },
        loginProc : function(context, loginInfo){
            return new Promise(function(resolve, reject){
                axios.post('/i5gam/member/login/loginProc.act',{
                    loginInfo : loginInfo
                }).then(function(response) {
                    resolve(response.data.loginProcInfo);
                }.bind(this)).catch(function(e) {
                    reject(e);
                });
            })
        },
        getLoginSession : function(){
            return new Promise(function (resolve, reject) {
                axios.post('/i5gam/member/login/loginChkProc.act',{}
                ).then(function(response) {
                    resolve(response.data.loginInfo);
                }.bind(this)).catch(function(e) {
                    reject(e);
                });
            });
        },
        logoutProc: function(context){
            return axios.post(
                '/i5gam/member/login/logoutProc.act',
                {}
            ).then(function() {
                context.commit('clearLoginInfo');
            }.bind(this)).catch(function(e) {
                console.log(e);
            });
        },
    }
});

export default store;
